import { createRouter, createWebHistory } from 'vue-router';
import ProductList from '../view/admin/ProductList.vue';
import AdminDashboard from '../view/admin/AdminDashboard.vue';
import HomePageSettings from '../view/admin/HomePageSettings.vue';
import BannerSettings from '../view/admin/BannerSettings.vue';
import AdminLogin from '../view/admin/AdminLogin.vue';
import ProductForm from '../view/admin/ProductForm.vue';
import Home from '../view/HomePage.vue';
import ProductsPage from '../view/ProductsPage.vue';
import ProductDetailPage from '../view/ProductDetailPage.vue';
import SolutionPage from '../view/SolutionPage.vue'; // 导入解决方案页面
import SolutionDetailPage from '../view/SolutionDetailPage.vue'; // 新增导入解决方案详情页
import ContactPage from '../view/ContactPage.vue'; // 导入联系我们页面
import TechSupportPage from '../view/TechSupportPage.vue'; // 导入技术支持页面
import TechSupportManagement from '@/view/admin/TechSupportManagement.vue'; // 导入技术支持管理页面
import ContactAboutSettings from '@/view/admin/ContactAboutSettings.vue';
import SolutionSettings from '@/view/admin/SolutionSettings.vue'; // 添加导入语句

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/solution',
    name: 'Solution',
    component: SolutionPage,
    meta: { title: { zh: '解决方案', en: 'Solutions' } }
  },
  // 新增解决方案详情页路由
  {
    path: '/solution/:id',
    name: 'SolutionDetail',
    component: SolutionDetailPage,
    meta: { title: { zh: '解决方案详情', en: 'Solution Details' } },
    props: true
  },
  {
    path: '/contact',
    name: 'Contact',
    component: ContactPage,
    meta: { title: { zh: '关于我们', en: 'About Us' } }
  },
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: AdminLogin,
    meta: { title: '管理员登录' }
  },
  // 新增前台产品页面路由
  {
    path: '/products',
    name: 'Products',
    component: ProductsPage,
    meta: { title: { zh: '产品中心', en: 'Products' } }
  },
  {
    path: '/tech-support',
    name: 'TechSupport',
    component: TechSupportPage,
    meta: { title: { zh: '技术支持', en: 'Technical Support' } }
  },
  {
    path: '/admin',
    name: 'AdminDashboard',
    component: AdminDashboard,
    meta: { title: '后台管理', requiresAuth: true },
    children: [
      {
          path: 'products',
          name: 'ProductList',
          component: ProductList,
          meta: { title: '产品管理' }
        },
        {
          path: 'home-settings',
          name: 'HomePageSettings',
          component: HomePageSettings,
          meta: { title: '首页设置' }
        },
        {
          path: 'banner-settings',
          name: 'BannerSettings',
          component: BannerSettings,
          meta: { title: 'Banner管理' }
        },
        
        {
        path: 'tech-support',
        name: 'TechSupportManagement',
        component: TechSupportManagement,
        meta: { title: '技术支持管理' }
        },
        {
          path: 'about-settings',
          component: () => import('@/view/admin/AboutSettings.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: 'contact-about-settings',
          name: 'ContactAboutSettings',
          component: ContactAboutSettings,
          meta: { title: '关于我们页面管理', requiresAuth: true }
        },
        {
          path: 'solutions',
          name: 'SolutionSettings',
          component: SolutionSettings,
          meta: { title: '解决方案管理', requiresAuth: true }
        },
        {
          path: 'ai-config',
          name: 'AIConfigSettings',
          component: () => import('@/view/admin/AIConfigSettings.vue'),
          meta: { title: 'AI模型配置', requiresAuth: true }
        }
      ]
    },
  // 删除原来的顶级路由定义
  {
    path: '/admin/products/add',
    name: 'AddProduct',
    component: ProductForm,
    meta: { title: '添加产品' }
  },
  {
    path: '/admin/products/edit/:id',
    name: 'EditProduct',
    component: ProductForm,
    meta: { title: '编辑产品' }
  },
  {
    path: '/product/:id',
    name: 'ProductDetail',
    component: ProductDetailPage
    // 组件使用 route.params.id 获取参数，不需要 props: true
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

// 设置页面标题的辅助函数
const setPageTitle = (route) => {
  // 获取当前语言
  const savedLang = localStorage.getItem('language') || 'zh';
  const locale = savedLang === 'en' ? 'en' : 'zh';
  
  // 设置页面标题
  let pageTitle = 'fabet 法彼特·中国';
  if (route.meta && route.meta.title) {
    if (typeof route.meta.title === 'object' && route.meta.title[locale]) {
      pageTitle = route.meta.title[locale] + ' - fabet 法彼特·中国';
    } else if (typeof route.meta.title === 'string') {
      pageTitle = route.meta.title + ' - fabet 法彼特·中国';
    }
  } else if (route.path === '/') {
    pageTitle = locale === 'en' ? 'Home - fabet 法彼特·中国' : '首页 - fabet 法彼特·中国';
  }
  document.title = pageTitle;
};

// 路由守卫 - 处理登录验证
router.beforeEach((to, from, next) => {
  // 设置页面标题
  setPageTitle(to);

  // 检查是否需要登录
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const isAuthenticated = localStorage.getItem('adminUser') !== null;

  if (requiresAuth && !isAuthenticated) {
    next('/admin/login');
  } else {
    next();
  }
});

// 路由后置守卫 - 监听语言变化时更新标题
router.afterEach((to) => {
  setPageTitle(to);
});

// 监听语言变化事件，更新当前页面标题
if (typeof window !== 'undefined') {
  window.addEventListener('languageChanged', () => {
    setPageTitle(router.currentRoute.value);
  });
}

export default router;